import CustomButton from "../../../../components/CustomButton";
import userRoles from "../../../../constants/userRoles";
import SvgIcon from "../../../../helpers/SvgIcon";
import { getDownloadDevice } from "../../../../redux/api/admin.api";
import { useAppDispatch } from "../../../../redux/hooks";
import { adminRoutes, crudRoutes } from "../../../../router/routesConstants";
import usePermissions from "../../../../router/usePermissions";
import Text from "../../../../styleguide/Text";

function DevicesNomenclatureCustomHeader() {
  const { isAuthorized } = usePermissions();
  const dispatch = useAppDispatch();

  const goToCreateDevicesNomenclature = () => {
    return `/${adminRoutes.devicesNomenclature}/${crudRoutes.create}`;
  };

  const handleDownloadDevice = async () => {
    await dispatch(getDownloadDevice({ idDevice: "model" }));
  };

  return (
    <div className="d-flex justify-content-between align-items-center mb-6">
      <Text variant="h3" component="h3" className="card-title">
        Nomenclator echipamente
      </Text>
      <div>
        <CustomButton
          className="me-1"
          variant="contained"
          tooltipTitle="Model"
          onClick={handleDownloadDevice}>
          <SvgIcon fill="white" type="DOCUMENT_WITH_DOWNLOAD" />
        </CustomButton>
        {isAuthorized(userRoles.DEVICES_NOMENCLATURE_CREATE) && (
          <CustomButton
            variant="contained"
            tooltipTitle="Creeaza"
            navigate={goToCreateDevicesNomenclature()}>
            <SvgIcon type="ADD" />
          </CustomButton>
        )}
      </div>
    </div>
  );
}

export default DevicesNomenclatureCustomHeader;
